"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
}); // TODO: Turn into a formal system or move out of systems

var ZIndex;

(function (ZIndex) {
  ZIndex[ZIndex["Header"] = 1000] = "Header";
  ZIndex[ZIndex["Modal"] = 2000] = "Modal";
  ZIndex[ZIndex["DropDown"] = 100] = "DropDown";
})(ZIndex || (ZIndex = {}));

exports.default = ZIndex;